module.exports = __webpack_public_path__ + "static/img/banner-csr-16.93c316c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-16.jpg
// module id = htcB
// module chunks = 99